import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import ROLE from "../common/role";

const AdminRoute = ({ children }) => {
  const { user, isLoading } = useSelector((state) => state.user);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-surface-muted">
        <div className="w-10 h-10 border-4 border-primary border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!user || user.role !== ROLE.ADMIN) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default AdminRoute;
